// import { required, email, max, min, confirmed } from "vee-validate/dist/rules";
// import { extend } from "vee-validate";
// import i18n from "./i18n";

// const fieldNames = ["required", "email", "confirmed", "max", "min"];
// fieldNames.forEach((fieldName) => {
//   extend(fieldName, {
//     ...required,
//     message: i18n.t(fieldName),
//   });
// });

import i18n from "./i18n";
import { extend } from "vee-validate";
import {
  required,
  email,
  confirmed,
  min,
} from "vee-validate/dist/rules.umd.js";
import { configure } from "vee-validate";

extend("required", required);
extend("email", email);
extend("confirmed", confirmed);
extend("min", min);

configure({
  // this will be used to generate messages.
  defaultMessage: (field, values) => {
    return i18n.t(`validations.messages.${values._rule_}`, values);
  },
});
